export * from "./colors";
export * from "./dependency-types";
export * from "./device";
export * from "./file-types";
export * from "./fonts";
export * from "./question-kinds";
export * from "./score-labels";
export * from "./screen-types";
export * from "./survey-mediums";
export * from "./titles";
export * from "./theme";
export * from "./configs";

export const PHONE_MIN_LENGTH = 5;
export const PHONE_MAX_LENGTH = 15;
export const MAX_FILE_SIZE = 10000000;
export const ANIMATION_DURATION = 1000;
export const OTHER_TEXT_MAX_LENGTH = 1000;
export const INVITES_STORE_ID = "submitted_invites";
export const META_OPTION_ACTION = { SELECT_ALL: "A", SELECT_NONE: "N" };
